import { forwardRef } from "react";
import { ComboBox as KComboBox } from "@progress/kendo-react-dropdowns";

import type { ComboBoxProps as KComboBoxProps } from "@progress/kendo-react-dropdowns";

export const Combobox = forwardRef((props: KComboBoxProps, _ref) => {
  const { className, ...otherProps } = props;
  return <KComboBox ref={_ref} className={`tc-combobox ${className}`} {...otherProps} />;
});
